// Real photographer headshots from the Team section (/api/staff) — fetched once, cached for the deck.
const API = process.env.REACT_APP_BACKEND_URL;
const POP_COUNT = 15;
let promise = null;
let list = [];
let picked = [];

function seeded(i) { const x = Math.sin(i * 9301 + 49297) * 233280; return x - Math.floor(x); }

// Deterministic spread across the whole team (same faces every run, every screen).
function pick(all) {
  if (!all.length) return [];
  const step = all.length / POP_COUNT;
  const out = [];
  for (let i = 0; i < Math.min(POP_COUNT, all.length); i += 1) {
    const idx = Math.min(all.length - 1, Math.floor(i * step + seeded(i + 900) * step));
    out.push(all[idx]);
  }
  return out;
}

export function loadTeamPhotos() {
  if (!promise) {
    promise = fetch(`${API}/api/staff/presentation-photographers`)
      .then((r) => (r.ok ? r.json() : { photographers: [] }))
      .then((d) => {
        list = (d.photographers || []).map((p) => ({ ...p, url: `${API}${p.photo}` }));
        picked = pick(list);
        return picked;
      })
      .catch(() => picked);
  }
  return promise;
}

export const getTeamPhotos = () => picked;
